export const API_ENV_CONFIG = {
	dev: {
		SWIPE_BASE_PATH: 'https://swipe.bharatpe.co.in/bharat-swipe',
		BP_CLUB_BASE_PATH: 'https://api-bpclub.bharatpe.co.in',
		MERCHANT_BASE_PATH: 'https://api-merchant.bharatpe.co.in/merchant',
		MERCHANT_BASE_PATH_V1: 'https://merchant-java.bharatpe.co.in/merchant',
		PAYMENTS_BASE_PATH: 'https://payments-tesseract.bharatpe.co.in/api/v1/merchant',
		MERCHANT_BACKEND_BASE_PATH: 'https://merchant-app-backend-qa.bharatpe.co.in/api/v1',
		KAAS_BASE_PATH: 'https://api-kaas.bharatpe.co.in/api',
		BASE_PATH_SPEAKER: 'https://bp-soundbox.bharatpe.co.in',
		BASE_SHERLOCK_PATH: 'https://sherlock-chargeback.bharatpe.co.in',
	},
	prod: {
		SWIPE_BASE_PATH: 'https://swipe.bharatpe.in/bharat-swipe',
		BP_CLUB_BASE_PATH: 'https://api-bpclub.bharatpe.in',
		MERCHANT_BASE_PATH: 'https://api-merchant.bharatpe.in/merchant',
		MERCHANT_BASE_PATH_V1: 'https://merchant-java.bharatpe.in/merchant',
		BASE_PATH_SPEAKER: 'https://bp-soundbox.bharatpe.in',
		BASE_SHERLOCK_PATH: 'https://sherlock-chargeback.bharatpe.in',
	},
	qa: {
		SWIPE_BASE_PATH: 'https://swipe.bharatpe.co.in/bharat-swipe',
		BP_CLUB_BASE_PATH: 'https://api-bpclub.bharatpe.co.in',
		MERCHANT_BASE_PATH: 'https://api-merchant.bharatpe.co.in/merchant',
		MERCHANT_BASE_PATH_V1: 'https://merchant-java.bharatpe.co.in/merchant',
		PAYMENTS_BASE_PATH: 'https://payments-tesseract.bharatpe.co.in/api/v1/merchant',
		MERCHANT_BACKEND_BASE_PATH: 'https://merchant-app-backend-qa.bharatpe.co.in/api/v1',
		KAAS_BASE_PATH: 'https://api-kaas.bharatpe.co.in/api',
		BASE_PATH_SPEAKER: 'https://bp-soundbox.bharatpe.co.in',
		BASE_SHERLOCK_PATH: 'https://sherlock-chargeback.bharatpe.co.in',
	},
};
